import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isControlInvalidAndTouched' })
export class IsControlInvalidAndTouchedPipe implements PipeTransform {
  transform(
    formControlTouched?: boolean,
    formControlInvalid?: boolean
  ): boolean {
    return !!(formControlInvalid && formControlTouched);
  }
}
